function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.958 14.093L7.68 9.671V4.676H3.966l-.008 9.417z",
  stroke: "#371447",
  strokeWidth: 1.13,
  fill: "#A1887F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.202 16.5l-.01-5.493 10.203-6.65 10.235 6.756v10.94H2.202V16.5zm3.471-2.772v7.911h4.14v-7.911h-4.14zm6.98-.449v4.836h6.134V13.28h-6.134z",
  fill: "#A1887F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.767 10.674V22.07h19.298V10.67l-9.67-6.382-9.628 6.387z",
  stroke: "#371447",
  strokeWidth: 1.13
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.73 11.32L12.167 3.42 1.063 11.248c.117.079.217.149.3.21.13.095.296.224.5.387l10.244-7.27 10.873 7.173.75-.429z",
  stroke: "#371447",
  strokeWidth: 0.692,
  fill: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  strokeWidth: 1.13,
  d: "M12.565 13.565h5.87v4.671h-5.87zM6 14h4.139v8.184H6zM0 22.2h25.313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 18.1V14",
  stroke: "#371447"
}));

function SvgHomeSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHomeSm;